/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GalleryDto2 } from '../../models/gallery-dto-2';
import { GalleryShowResponse2 } from '../../models/gallery-show-response-2';

export interface PatchGalleryUpdate$Params {
  name: string;
      body: GalleryDto2
}

export function patchGalleryUpdate(http: HttpClient, rootUrl: string, params: PatchGalleryUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<GalleryShowResponse2>> {
  const rb = new RequestBuilder(rootUrl, patchGalleryUpdate.PATH, 'patch');
  if (params) {
    rb.path('name', params.name, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GalleryShowResponse2>;
    })
  );
}

patchGalleryUpdate.PATH = '/v1/gallery/{name}';
